import React, { Component } from 'react'
import Link from '../utils/link'
import { YouTube, Instagram, WeChat, Facebook, LinkedIn } from './icons'

class SocialIcons extends Component {

  render() {

    let { color } = this.props

    return (
      
      <div className='social-icons'>

        <ul>
          <li><Link to='https://www.linkedin.com/company/kollosche/'><LinkedIn color={color} /></Link></li>
          <li><Link to='https://www.facebook.com/KolloscheGC/'><Facebook color={color} /></Link></li>
          <li><Link to='https://www.instagram.com/kollosche_/'><Instagram color={color} /></Link></li>
          <li><Link to='https://weixin.qq.com/r/mzsCGrXEGehmrfF5926J'><WeChat color={color} /></Link></li>
          <li><Link to='https://www.youtube.com/channel/UCyVdEOWfroQCK9ScWZuCODA'><YouTube color={color} /></Link></li>
        </ul>

      </div> 
    )
  }
}

export default SocialIcons